// Modules
import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'

// Pages
import Login from 'pages/login/Login'
import Register from 'pages/register/Register'
import Reset from 'pages/reset/Reset'
import Verification from 'pages/verification/Verification'

// Route: Unprotected
function Unprotected () {
	// Effects
	useEffect(() => {
		let script
		if (!document.getElementById('google-identity-script')) {
			script = document.createElement('script')
			script.src = 'https://accounts.google.com/gsi/client'
			script.async = true
			script.defer = true
			script.id = 'google-identity-script'
			document.head.appendChild(script)
		}
		return () => {
			if (!!script) document.head.removeChild(script)
			Array
				.from(document.querySelectorAll('[id^="google"]'))
				.forEach(itemToRemove => itemToRemove.parentElement.removeChild(itemToRemove))
		}
	}, [])
	useEffect(() => {
		let script
		if (!document.getElementById('apple-identity-script')) {
			script = document.createElement('script')
			script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js' // TODO: Handle localization
			script.id = 'apple-identity-script'
			document.head.appendChild(script)
		}
		return () => {
			if (!!script) document.head.removeChild(script)
			Array
				.from(document.querySelectorAll('[id="apple-identity-script"]'))
				.forEach(itemToRemove => itemToRemove.parentElement.removeChild(itemToRemove))
		}
	}, [])

	// Render
	return (
		<Routes>
			{/* Login */}
			<Route
				path="login"
				element={<Login />} />
			{/* Register */}
			<Route
				path="register"
				element={<Register />} />
			{/* Reset */}
			<Route
				path="reset"
				element={<Reset />} />
			{/* Verification */}
			<Route
				path="verification"
				element={<Verification />} />
			{/* Fallback */}
			<Route
				path="*"
				element={<Login />} />
		</Routes>
	)
}

// Export
export default Unprotected
